/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_AnswerInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not from the editor URL alone. Save and transfer the workbook file, then open that file on the other device. Signing into this website is not a substitute for saving a workbook.`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅凭编辑器网址不行。请先保存并传输工作簿文件，再在另一台设备打开。登录本网站也不能替代保存工作簿。`)
};

/**
* | output |
* | --- |
* | "Not from the editor URL alone. Save and transfer the workbook file, then open that file on the other device. Signing into this website is not a substitute fo..." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_1_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_1_answer(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_1_answer(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_1_answer as "gc.search_guides.gridcraft_online.sections.7.questions.1.answer" }